import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationItem from './NavigationItem';
import { ChevronDown } from '../icons';
import './NavigationDropdown.scss';

const NavigationDropdown = ({
  items = [],
  navigationTitle,
  expanded,
  expandHandler,
  itemType,
  parentSlug = '',
  currentModule = null,
  currentDischargeStep = null,
  currentLesson = null
}) => {
  
  // 1. Memoize sorted items to avoid re-sorting on every render
  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => (a.menu_order || 0) - (b.menu_order || 0));
  }, [items]);

  return (
    <div
      className={classNames('dropdown-navigation', itemType, {
        'dropdown-navigation--open': expanded
      })}
    >
      {/* 2. Accessible Trigger Button */}
      <button
        type="button"
        aria-expanded={expanded}
        className={classNames('dropdown-navigation__title', {
          'dropdown-navigation__title--open': expanded
        })}
        onClick={expandHandler}
      >
        <span className="dropdown-navigation__title-text">
          {navigationTitle}
        </span>
        <ChevronDown width="32" height="32" />
      </button>

      {/* 3. Panel Container */}
      <div
        className={classNames('dropdown-navigation__panel', {
          'dropdown-navigation__panel--open': expanded
        })}
      >
        <ul className="dropdown-navigation__list">
          
          {/* PARENT SECTION: Intro Modules */}
          {currentModule && (
            <li className="dropdown-navigation__list-item__parent-content">
              <button type="button" onClick={expandHandler}>
                <NavigationItem
                  parentSlug={parentSlug}
                  itemType="module"
                  module={currentModule}
                  isParentContent
                  displayProgressIcon
                />
              </button>
            </li>
          )}

          {/* INTRO PAGES (Chapter specific) */}
          {currentModule?.acf?.pages?.map((page) => (
            <li className="dropdown-navigation__list-item" key={page.ID}>
              <button type="button" onClick={expandHandler}>
                <NavigationItem
                  parentSlug={parentSlug}
                  itemType="chapter-intro-page"
                  module={currentModule}
                  chapterIntroPage={page}
                  isParentContent={false}
                  displayProgressIcon={false}
                />
              </button>
            </li>
          ))}

          {/* DISCHARGE PARENT */}
          {currentDischargeStep && (
            <li className="dropdown-navigation__list-item__parent-content">
              <button type="button" onClick={expandHandler}>
                <NavigationItem
                  parentSlug={parentSlug}
                  itemType="discharge"
                  module={currentDischargeStep}
                  isParentContent
                  displayProgressIcon={false}
                />
              </button>
            </li>
          )}

          {/* LESSON PARENT */}
          {currentLesson && (
            <li className="dropdown-navigation__list-item__parent-content">
              <button type="button" onClick={expandHandler}>
                <NavigationItem
                  parentSlug={parentSlug}
                  itemType="lesson-topics-nav"
                  module={currentLesson}
                  isParentContent
                  displayProgressIcon={false}
                />
              </button>
            </li>
          )}

          {/* DYNAMIC LIST: The main items (Lessons or Topics) */}
          {sortedItems.map((item) => (
            <li className="dropdown-navigation__list-item" key={item.ID}>
              <button type="button" onClick={expandHandler}>
                <NavigationItem
                  parentSlug={parentSlug}
                  itemType={itemType}
                  module={item}
                  progress={item.completion}
                  itemTitle={itemType}
                  isParentContent={false}
                  displayProgressIcon
                />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

NavigationDropdown.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    completion: PropTypes.number,
    menu_order: PropTypes.number
  })),
  navigationTitle: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  expandHandler: PropTypes.func.isRequired,
  itemType: PropTypes.string.isRequired,
  parentSlug: PropTypes.string,
  currentModule: PropTypes.shape({
    acf: PropTypes.shape({
      pages: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }),
  currentDischargeStep: PropTypes.shape({}),
  currentLesson: PropTypes.shape({})
};

export default NavigationDropdown;
